import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InfoBox } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledWarningBox = styled(InfoBox)<{ isDarkMode: boolean }>`
  background-color: ${({ isDarkMode }) => (isDarkMode ? 'rgba(235, 0, 55, 0.1)' : 'rgba(253, 230, 235, 1)')};
  border: 0.1rem solid ${({ theme }) => theme.colors.error.main};
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
  display: flex;
  align-items: center;
  gap: 1.4rem;
`;

export const StyledExclamationIcon = styled(FontAwesomeIcon)`
  && {
    height: 2rem;
    width: 2rem;
    color: ${({ theme }) => theme.colors.error.main};
  }
`;

export const StyledWarningText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
`;
